export const INITIAL_DASHBOARD_FILTER_PARAMS = {
  isPrivate: null,
  isShared: null,
  searchCriteria: '',
  tagIds: null,
};
